import React from 'react'

import { useStaticQuery, graphql } from 'gatsby'

import BodyTextTemplate from '../components/bodyTextTemplate'

import Layout from '../components/layout'

const About = () => {

    const data = useStaticQuery(graphql`
        query {
            allContentfulAbout {
                nodes {
                    title
                    body {
                        raw
                    }
                }
            }
            allContentfulAsset {
                nodes {
                    contentful_id
                    title
                    gatsbyImageData
                }
            }
        }      
    `)

    const { body } = data.allContentfulAbout.nodes[0]
    const assetData = data.allContentfulAsset.nodes

    return (
        <Layout showHeader={true}>
            <section>
                <div className="mx-6 blogpost-mobile">
                    <div className="my-6">
                        <h1 className="is-size-1 is-size-2-mobile has-text-centered">About</h1>
                    </div>

                    <div className="column is-10 is-offset-1">
                        <BodyTextTemplate richTextField={body} assetData={assetData} />
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default About
